(() => {
  if (window.seVideoInit) { window.seVideoInit(); return; }
  const load = video => {
    if (video.dataset.loaded) return;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
    });
    video.dataset.loaded = 'true';
    video.preload = 'auto';
    video.load();
  };
  const play = video => {
    load(video);
    video.play().catch(() => { if (!video.paused || video.dataset.visible !== 'true') return; video.controls = true; });
  };
  const near = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { load(entry.target); near.unobserve(entry.target); } });
  }, { rootMargin: '300px' }) : null;
  const visible = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.dataset.visible = String(entry.isIntersecting);
      if (entry.isIntersecting && !document.hidden) play(entry.target);
      else entry.target.pause();
    });
  }) : null;
  window.seVideoInit = () => {
    document.querySelectorAll('video[data-se-deferred]:not([data-se-observed])').forEach(video => {
      video.dataset.seObserved = 'true';
      if (near) { near.observe(video); visible.observe(video); }
      else { load(video); video.controls = true; }
    });
  };
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('video[data-se-deferred]').forEach(video => {
      if (document.hidden) video.pause();
      else if (video.dataset.visible === 'true') play(video);
    });
  });
  document.addEventListener('shopify:section:load', window.seVideoInit);
  window.seVideoInit();
})();
